import { useForm } from 'react-hook-form';

import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';

import { Typography, Box } from '@mui/material';
import MuiDialog from 'components/MuiDialog';

import { SurveyDialogProps, TDNRTwoDefaultValues } from '../../type';
import { updateDNRTwo } from 'apis/survey';

import CommonPatientInfo from '../../components/CommonPatientInfo';
import DNRcontents1 from './DNRcontents1';
import DNRsig1 from './DNRsig1';
import Signature from './Signature';
import DNRcontents2 from './DNRcontents2';
import DNRsig2 from './DNRsig2';

const DNRTwo = (props: SurveyDialogProps<TDNRTwoDefaultValues>) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    nurseName,
    patientInfo,
    onClose,
  } = props;

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();
  const { handleSubmit, watch, getValues, setValue, register } = useForm({
    defaultValues,
  });

  const onSubmit = (data: TDNRTwoDefaultValues) => {
    const {
      check,

      no1_name,
      no1_relationship,
      no1_id,
      no1_contact,
      no1_sig,

      no2_name,
      no2_relationship,
      no2_id,
      no2_contact,
      no2_sig,

      no3_name,
      no3_relationship,
      no3_id,
      no3_contact,
      no3_sig,

      doc_name,
      doc_sig,
      doc_license_no,
      specialist_license_no,

      specialist_name,
      specialist_sig,
      specialist_specialty,
      specialist_institute,
    } = data;

    const request = {
      user_id,
      patient_id: patientInfo.patient_id,
      dnr_confirmation: {
        check,

        no1_name,
        no1_relationship,
        no1_id,
        no1_contact,
        no1_sig,

        no2_name,
        no2_relationship,
        no2_id,
        no2_contact,
        no2_sig,

        no3_name,
        no3_relationship,
        no3_id,
        no3_contact,
        no3_sig,

        doc_name,
        doc_sig,
        doc_license_no,
        specialist_license_no,

        specialist_name,
        specialist_sig,
        specialist_specialty,
        specialist_institute,
      },
    };

    updateDNRTwo(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);

        onUpdateIsSave(true);
        onSuccess('저장되었습니다');
      })
      .catch(e => {
        onFail('저장에 실패하였습니다', e);
      });
  };

  const formProps = {
    disabled,
    watch,
    getValues,
    setValue,
    onSuccess,
    onRequired,
    register,
  };

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Typography
        sx={{
          margin: '40px auto 40px auto',
          fontWeight: '700',
          fontSize: '16px',
          textAlign: 'center',
        }}
      >
        연명의료중단등결정에 대한 친권자 및 환자 가족 의사 확인서
      </Typography>
      <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
      <Box sx={{ marginTop: '48px' }}>
        {/* <DNRcontents1 {...formProps} />
        <DNRsig1 {...formProps} /> */}
        <DNRcontents2 {...formProps} />
        <DNRsig2 {...formProps} />
        <Signature {...formProps} />
      </Box>
    </MuiDialog.SurveyForm>
  );
};

export default DNRTwo;
